module.exports = __webpack_public_path__ + "static/img/title-bar.a8b650e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/title-bar.jpg
// module id = slwS
// module chunks = 1